<div class="magic-login-page">
  <div class="card">
    <div class="logo">
      <img src="assets/talentmarket.logo.svg" alt="TalentMarket" />
    </div>

    <ng-container [ngSwitch]="state">
      <div *ngSwitchCase="'loading'" class="state-block">
        <mat-spinner diameter="48"></mat-spinner>
        <p class="status-text">Prijavljivanje u tijeku...</p>
      </div>

      <div *ngSwitchCase="'error'" class="state-block">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h2 class="title">Prijava nije uspjela</h2>
        <p class="message">{{ errorMessage }}</p>
        <button type="button" class="primary-btn" (click)="goToLogin()">
          Idi na prijavu
        </button>
      </div>
    </ng-container>
  </div>
</div>
